// extracted by mini-css-extract-plugin
module.exports = {"paper":"ModalRegCode_paper__2nqbt"};